module.exports = __webpack_public_path__ + "static/foe_news_1-c2854b6f31e47722b4e2907c33a9fd98.jpg";